/**
 * BackgroundLayer - Static gradient base background
 * Always rendered, never animated
 * Ensures consistent color on all devices
 */
function BackgroundLayer() {
  return <div className="animation-layer layer-background" data-testid="background-layer" />;
}

export default BackgroundLayer;
